const sections = {
  BasicDetails: {
    value: 'BASIC_DETAILS',
    label: 'user.details.basicDetails'
  }
}
export default sections
